import React from 'react';

import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(() => {
  return {
    buttonContainer: {
      marginTop: '1rem',
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      justifyContent: 'center',
      maxWidth: '45.3rem',
    },
  };
});

export default () => {
  const classes = useStyles();
  const history = useHistory();
  const onLogin = () => history.push('/login');

  return (
    <Container component="main" className={classes.mainContainer}>
      <Container component="div" disableGutters>
        <Typography variant="h4" className="mb-1 page-header" align="center">
          You have been logged out due to Inactivity
        </Typography>
      </Container>
      <Grid container direction="column" justify="center">
        <Grid item className={classes.buttonContainer}>
          <Button variant="contained" color="primary" onClick={onLogin}>
            Go to Login
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};
